export default __webpack_public_path__ + "static/media/title.852ceb95.png";